import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b94b724c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bill-tips fix-title-box van-hairline--bottom" }, null, -1))
const _hoisted_3 = { class: "bill-detail" }
const _hoisted_4 = { class: "item-title" }
const _hoisted_5 = {
  key: 0,
  class: "item-num"
}
const _hoisted_6 = { class: "item-num" }
const _hoisted_7 = { class: "price" }
const _hoisted_8 = { class: "bill-total" }
const _hoisted_9 = { class: "total-price" }
const _hoisted_10 = { class: "price" }


import BlockkWrapper from '../block-wrap.vue'
import { ServiceBillInfo } from '@/types/malfunction-repair'

export default /*#__PURE__*/_defineComponent({
  __name: 'detail-bill-block',
  props: {
    payInfo: null
  },
  setup(__props: any) {

const props = __props as {
  payInfo: ServiceBillInfo
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockkWrapper, { title: "账单费用" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.payInfo.billArr, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "van-hairline--bottom",
                key: index
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(`${item.title} ${item.titleRule?`（${item.titleRule}）`:''}`), 1),
                  (item.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.description), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(`¥ ${item.price} x${item.num}`), 1)
                ]),
                _createElementVNode("div", _hoisted_7, "¥" + _toDisplayString(item.sum), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode(" 服务费用合计： "),
            _createElementVNode("span", _hoisted_10, "￥" + _toDisplayString(props.payInfo.sum), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})